<template>
  <el-row>
    <el-col>
      <el-card>
        <el-row>
          <el-col>
            <el-tabs v-model="activeTab">
              <el-tab-pane name="KpiSatisfaccion" label="Satisfaccion">
                <KpiSatisfaccion />
              </el-tab-pane>

              <el-tab-pane
                name="KpiSatifaccionGerencia"
                label="Satisfaccion Gerencia"
              >
                <KpiSatifaccionGerencia />
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import KpiSatisfaccion from "./KpiSatisfaccion.vue";
import KpiSatifaccionGerencia from "./KpiSatifaccionGerencia.vue";

export default {
  data() {
    return {
      activeTab: "KpiSatisfaccion"
    };
  },

  components: {
    KpiSatisfaccion,
    KpiSatifaccionGerencia
  }
};
</script>

<style></style>
